import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm} from 'antd';
import axios from 'axios';
import EthnicityDialogForm from './EthnicityForm';
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

class Ethnicity extends Component{
  
  state = {
    datalist: [],
    ethnicity: {},
    visible: false,
    requestType: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'Ethnicity',
      dataIndex: 'ethnicity',
      key: 'ethnicity'
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.datalist.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/systemsetup/ethnicity/`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/systemsetup/ethnicity/`, {
              ethnicity: values.ethnicity
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/systemsetup/ethnicity/${this.state.ethnicity.id}/`, {
             ethnicity: values.ethnicity
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({ethnicity: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/systemsetup/ethnicity/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({ethnicity: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_ethnicity') > -1 ? 
              <Button type="primary" onClick={() => this.showModal('post')}>Add Ethnicity</Button>
              : ''
            }

            {
              this.props.userPermissions.indexOf('view_ethnicity') > -1 ?
              <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id"/>
              : 'You do not have rights to view Ethnicity. Please Contact your Administrator'
            }

            <EthnicityDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.ethnicity}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(Ethnicity);
// export default Ethnicity;
